import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header: React.FC = () => {
  const location = useLocation();
  
  const isActive = (path: string) => {
    if (path === '/personal-data') {
      // Consider all form pages as part of the "Neue Melderegisterauskunft" flow
      return location.pathname.startsWith('/personal-data') || 
             location.pathname.startsWith('/address-data') ||
             location.pathname.startsWith('/known-info') ||
             location.pathname.startsWith('/address-details') ||
             location.pathname.startsWith('/birthdate') ||
             location.pathname.startsWith('/both-info') ||
             location.pathname.startsWith('/no-info') ||
             location.pathname.startsWith('/email');
    }
    return location.pathname.startsWith(path);
  };
  
  // Check if user is in the funnel - hide navigation to avoid distractions
  const isInFunnel = location.pathname.startsWith('/personal-data') || 
                     location.pathname.startsWith('/address-data') ||
                     location.pathname.startsWith('/known-info') ||
                     location.pathname.startsWith('/address-details') ||
                     location.pathname.startsWith('/birthdate') ||
                     location.pathname.startsWith('/both-info') ||
                     location.pathname.startsWith('/no-info') ||
                     location.pathname.startsWith('/email') ||
                     location.pathname.startsWith('/loading') ||
                     location.pathname.startsWith('/payment') ||
                     location.pathname.startsWith('/success') ||
                     location.pathname.startsWith('/processing');
  
  return (
    <header className="w-full">
      <div 
        className="py-3 text-center"
        style={{
          backgroundColor: '#023047', // Using the --primary color from your list
          color: 'white',
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, sans-serif',
          fontSize: '1rem',
          lineHeight: 1.35,
          WebkitFontSmoothing: 'antialiased',
          wordBreak: 'break-word',
          hyphens: 'initial',
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        <p className="px-4" style={{ fontWeight: 700 }}>Melderegisterauskunft Online – Schnell & Zuverlässig</p>
      </div>
      <div className="py-4 border-b border-gray-200 text-center">
        <Link to="/" className="inline-block">
          <div 
            className="text-2xl tracking-tight hover:text-blue-600 transition-colors"
            style={{ 
              color: '#023047',
              fontWeight: 700,
              fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, sans-serif',
            }}
          >
            AdressFinder.org
          </div>
        </Link>
      </div>
      
      {/* Navigation Menu - Hidden in funnel to avoid distractions */}
      {!isInFunnel && (
        <nav className="border-b border-gray-200">
          <div className="container mx-auto px-4" style={{ maxWidth: '1200px' }}>
            <ul className="flex flex-nowrap justify-center gap-x-1 md:gap-x-2">
              <li>
                <Link
                  to="/personal-data"
                  className="block whitespace-nowrap px-2 md:px-6 py-3 md:py-4 text-sm md:text-base font-medium transition-colors relative"
                  style={{
                    color: isActive('/personal-data') ? '#023047' : '#4b5563',
                    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, sans-serif',
                    borderBottom: isActive('/personal-data') ? '3px solid #023047' : '3px solid transparent',
                  }}
                >
                  <span className="md:hidden">Neue Auskunft</span>
                  <span className="hidden md:inline">Neue Melderegisterauskunft</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/einwohnermeldeamt"
                  className="block whitespace-nowrap px-2 md:px-6 py-3 md:py-4 text-sm md:text-base font-medium transition-colors relative"
                  style={{
                    color: isActive('/einwohnermeldeamt') ? '#023047' : '#4b5563',
                    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, sans-serif',
                    borderBottom: isActive('/einwohnermeldeamt') ? '3px solid #023047' : '3px solid transparent',
                  }}
                >
                  <span className="md:hidden">Meldeämter</span>
                  <span className="hidden md:inline">Einwohnermeldeämter in Deutschland</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/erfahrungen"
                  className="block whitespace-nowrap px-2 md:px-6 py-3 md:py-4 text-sm md:text-base font-medium transition-colors relative"
                  style={{
                    color: isActive('/erfahrungen') ? '#023047' : '#4b5563',
                    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, sans-serif',
                    borderBottom: isActive('/erfahrungen') ? '3px solid #023047' : '3px solid transparent',
                  }}
                >
                  Erfahrungen
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;
